var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:gray}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(-119.623 -120.096) scale(1.40041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.54 323.88c-15.31 0-29.7-5.96-40.53-16.79-22.35-22.35-22.35-58.71 0-81.06 10.83-10.83 25.22-16.79 40.53-16.79 15.31 0 29.7 5.96 40.53 16.79 10.83 10.83 16.79 25.22 16.79 40.53 0 15.31-5.96 29.7-16.79 40.53-10.82 10.82-25.22 16.79-40.53 16.79zm0-107.39c-13.37 0-25.95 5.21-35.4 14.66-19.52 19.52-19.52 51.28 0 70.81 9.46 9.46 22.03 14.66 35.4 14.66 13.37 0 25.95-5.21 35.4-14.66 19.52-19.52 19.52-51.28 0-70.81-9.45-9.45-22.02-14.66-35.4-14.66z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.54 340.13c-19.65 0-38.13-7.65-52.02-21.55-28.68-28.68-28.68-75.36 0-104.04 13.9-13.9 32.37-21.55 52.02-21.55 19.65 0 38.13 7.65 52.02 21.55 28.68 28.68 28.68 75.36 0 104.04-13.89 13.9-32.37 21.55-52.02 21.55zm0-139.89c-17.72 0-34.37 6.9-46.9 19.43-25.86 25.86-25.86 67.93 0 93.79 12.53 12.53 29.18 19.42 46.9 19.42 17.71 0 34.37-6.9 46.9-19.42 25.86-25.86 25.86-67.93 0-93.79-12.53-12.53-29.18-19.43-46.9-19.43z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "polygon8",
    d: "m363.39 323.39 5.43-4.8 17.01 19.24 6.99-6.99-19.24-17 4.8-5.43 25.01 22.11-17.89 17.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.24 433.85a12.7 12.7 0 0 1-9.57-4.34l-59.18-67.52c-5.45-6.22-5.14-15.68.71-21.53l12.25-12.25c2.98-2.98 6.93-4.61 11.14-4.61 3.82 0 7.51 1.39 10.38 3.91l67.52 59.18c2.64 2.31 4.22 5.65 4.33 9.15.11 3.5-1.24 6.94-3.72 9.41l-24.87 24.87c-2.4 2.4-5.59 3.73-8.99 3.73zm-44.65-103c-2.27 0-4.41.88-6.02 2.49l-12.25 12.25c-3.16 3.16-3.33 8.27-.38 11.63l59.18 67.52a5.467 5.467 0 0 0 4.12 1.87c1.46 0 2.84-.57 3.87-1.6l24.87-24.87a5.425 5.425 0 0 0 1.6-4.05 5.429 5.429 0 0 0-1.86-3.94l-67.52-59.18a8.495 8.495 0 0 0-5.61-2.12z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.11 436.17c-5.39 0-10.78-2.05-14.89-6.16l5.12-5.13c5.39 5.38 14.14 5.38 19.53 0 5.38-5.38 5.38-14.14 0-19.53l5.13-5.12c8.21 8.21 8.21 21.57 0 29.78-4.11 4.11-9.5 6.16-14.89 6.16z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "polygon14",
    d: "m297.85 268.42 5.12-5.12 12.8 12.8 26.77-26.77 5.13 5.13-31.9 31.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "polygon18",
    d: "M428.68 161.68H214.41v276.5h214.27v-12.5l7.25 8.27v11.48H207.16v-291h228.77v180.05l-7.25-6.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "polygon20",
    d: "M179.08 430.54V169.32h21.39v7.25h-14.14v246.72h14.14v7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "polygon22",
    d: "M151 415.5V184.36h21.39v7.25h-14.15v216.64h14.15v7.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect26",
    d: "M237.12 387.74h7.25v27.56h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect28",
    d: "M253.43 377.51h7.25v37.79h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect30",
    d: "M269.75 392.09H277v23.21h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect32",
    d: "M286.06 367.07h7.25v48.23h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect34",
    d: "M302.38 384.36h7.25v30.94h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect36",
    d: "M318.69 377.51h7.25v37.79h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect38",
    d: "M335.01 393.46h7.25v21.84h-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect40",
    d: "M351.32 386.48h7.25v28.82h-7.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(-119.623 -120.096) scale(1.40041)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.79,
    cy: 326.62,
    r: 13.45,
    id: "circle48",
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.79,
    cy: 366.97,
    r: 13.45,
    id: "circle50",
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.79,
    cy: 286.28,
    r: 13.45,
    id: "circle52",
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.79,
    cy: 245.93,
    r: 13.45,
    id: "circle54",
    style: {
      fill: "#e79933"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.eb7c85543188740f966450ab3fb13672.svg";
export { ForwardRef as ReactComponent };